import {MerchantOfRecord} from '../../api-types/bovio/response/booking'

/**
 *
 * Receives an {@link Offer} as parameter and determines if FindHotel is the
 * MOR (merchant of record) for that rate
 * @returns boolean to whether FindHotel is the MoR or not
 * @param offer The offer you are checking if it's FH MOR or not
 * @param offer.merchantOfRecord The merchant of record for the offer
 */
const isFhMor = (offer?: {
  merchantOfRecord?: string | MerchantOfRecord | null
}) => offer?.merchantOfRecord === MerchantOfRecord.Findhotel

export default isFhMor
